import React from "react";
import "./Sections.scss";

function QA1() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          You’ve traveled the world—and yet you keep returning to your home,
          Italy. What makes it different from other places?
        </p>
        <p className="interview__interview__copy">
          For me Italy is the best, most wonderful theater in the world—an
          open-air theater where everybody can decide what role to play. And I
          have decided to play the Explorer of Beauty.
        </p>
        <p className="interview__interview__copy">
          As Italians, beauty is in our DNA. We have the good fortune to be born
          in a place where we are surrounded by art. Maybe we just get used to
          the beauty immediately and then we can’t live without it.
        </p>
      </div>
    </section>
  );
}

export default QA1;
